import EmpoweredCommunity from "../images/empowered-community.jpg"
import Evaluation from "../components/Evaluation"
import Greatness from "../components/Greatness"
import JoinCommunity from "../components/JoinCommunityRowV2"
import PowerUpDown from "../components/PowerUpDown"
import Layout from "../components/layout"
import Quote from "../components/Quote"
import React from "react"
import Helmet  from "react-helmet"
import SEO from "../components/seo"
import Button from "../components/Button"
import styles from "../styles/empowered-v2.module.scss"

// Static Home V2 Page
const HomeV2Page = ({ data }) => (
  <Layout>
    <Helmet>
      <title>The em•powered Community | em•power with Shawna</title>
      <meta name="title" content="The em•powered Community" />
      <meta name="description" content="Learn about the em•powered community and join us on our journey to health and wellness. Let’s be better versions of ourselves by following our ethos manifest!" />   
    </Helmet>

    <section className={styles.intro}>
      <div className={styles.intro_txt}>
        <p>My name is Shawna Korgan and I’m here to help you change the world.</p>
        <div className={styles.intro_txt_btn}>
          <Button
            href={"https://member.empowerofyou.com/log-in/"}
            backgroundColor={"#ffbe76"}
            label={"SIGN IN"}
            fontSize={"18px"}
            target={"_blank"}
            outlineColor={"#ffbe76"}
          />
          <Button
            href={"https://member.empowerofyou.com/checkout/?add-to-cart=6284"}
            backgroundColor={"#ffbe76"}
            label={"GET STARTED"}
            fontSize={"18px"}
            target={"_blank"}
            outlineColor={"#ffbe76"}
          />
        </div>
      </div>
    </section>

    <Evaluation />

    <section className={styles.homeVideo}>
      <div className={styles.homeVideo_video}>
        <iframe src="https://player.vimeo.com/video/453471689" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
      </div>
      <div className={styles.homeVideo_text}>
        <h2 className={styles.homeVideo_text_title}>Copy from my heart of why em•power</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent lacinia et felis in ultricies. Donec et dui eget nunc tincidunt consectetur ut eu arcu. Pellentesque sagittis porttitor pulvinar. Suspendisse elementum sit amet lectus eget molestie. Aenean ut augue lobortis, tristique nunc non, consectetur mi. Nulla ac efficitur dolor, sed accumsan eros.</p>
      </div>
    </section>

    <section className={styles.joinCommunityRow}>
      <JoinCommunity />
    </section>

    <PowerUpDown />

  </Layout>
)

export default HomeV2Page

{
  /*
export const query = graphql`
  query {
    allWordpressWpMedia {
      edges {
        node {
          localFile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
 */
}
